import React from "react";
import { getDrivingDistanceLabel } from "../utils/insurance";
import StoreAction from "../constants/store-action";
import UserEvent from "../constants/user-event";
import AccordionItem from "./insurance-alternative-accordion";
import AddonItem from "./insurance-alternative-item";
export default (props) => {
    const [isExtended, setIsExtended] = React.useState(false);
    const handleHasAddedInsuranceClick = (hasAddedInsurance) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "insurance",
            name: "hasAddedInsurance",
            value: hasAddedInsurance,
        }, () => {
            if (hasAddedInsurance) {
                props.onIncompleteUserEvent(UserEvent.INSURANCE_ADDED);
            }
            else {
                props.onIncompleteUserEvent(UserEvent.INSURANCE_SKIPPED);
            }
            props.onProceedToNextStep();
        });
    };
    const handleMoreInformationClick = () => {
        setIsExtended(!isExtended);
    };
    const insuranceOption = props.insuranceOptions.getInsuranceOption();
    const drivingDistanceText = getDrivingDistanceLabel(props.data.insurance.expectedDrivingDistance);
    const accordionItems = insuranceOption.items.map((i, index) => (React.createElement(AccordionItem, Object.assign({ key: index }, i))));
    const hasAccordionItems = accordionItems.length > 0;
    const allIncludedAddons = insuranceOption.addons.filter((a) => props.data.insurance.addons.includes(a.name));
    const allExcludedAddons = [].concat(...allIncludedAddons.map((a) => a.excludes));
    const addonItems = insuranceOption.addons.map((a, index) => {
        const isDisabled = allExcludedAddons.includes(a.name);
        return (React.createElement(AddonItem, Object.assign({ key: index, id: `insurance-addon-${index}`, isDisabled: isDisabled }, a, props)));
    });
    const hasAddonItems = addonItems.length > 0;
    const onChooseInsurance = () => handleHasAddedInsuranceClick(true);
    const onSkipInsurance = () => handleHasAddedInsuranceClick(false);
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, insuranceOption.brand.name)),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-columnrow": "", className: "font-size-small m-b-half" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "font-medium" }, "Uppgifter")),
                React.createElement("div", { className: "column" },
                    React.createElement("button", { "data-ecom-link": "font-inerit", onClick: props.onShowInsuranceInformationDefinition }, "\u00C4ndra"))),
            React.createElement("div", { className: "l-inline-block m-r" },
                React.createElement("i", { className: "icon-profile m-r-half" }),
                props.data.insurance.personalNumber),
            React.createElement("div", { className: "l-inline-block" },
                React.createElement("i", { className: "icon-mileage m-r-half" }),
                React.createElement("span", null, drivingDistanceText))),
        React.createElement("section", { className: "page-section page-section-accent" },
            React.createElement("div", { className: "repeat-m-half" },
                React.createElement("div", { "data-ecom-box": "light", className: isExtended ? "is-extended" : "" },
                    React.createElement("h2", { className: "h6" },
                        insuranceOption.price,
                        " ",
                        insuranceOption.unit),
                    React.createElement("div", { "data-ecom-content": "" },
                        React.createElement("p", null, insuranceOption.name)),
                    React.createElement("div", { className: "box-extend" },
                        React.createElement("div", { "data-ecom-content": "", className: "m-b" },
                            React.createElement("p", null, insuranceOption.description)),
                        React.createElement("div", { "data-ecom-content": "", className: "m-b" },
                            React.createElement("a", { "data-ecom-link": "", href: insuranceOption.conditions.url, target: "_blank", rel: "noopener noreferrer" },
                                insuranceOption.conditions.description,
                                React.createElement("i", { className: "icon-link-external m-l-half" }))),
                        hasAddonItems && (React.createElement("div", { className: "m-b" }, addonItems)),
                        React.createElement("div", { className: "font-medium m-b" }, "F\u00F6rs\u00E4kringen inneh\u00E5ller"),
                        hasAccordionItems && (React.createElement("div", { "data-ecom-accordion": "" },
                            React.createElement("ul", { className: "accordion" }, accordionItems)))),
                    React.createElement("div", { className: "box-footer" },
                        React.createElement("div", { "data-ecom-columnrow": "" },
                            React.createElement("div", { className: "column font-size-small" },
                                React.createElement("button", { "data-ecom-link": "action font-size-inherit", className: "l-block", onClick: handleMoreInformationClick },
                                    isExtended ? "Mindre" : "Mer",
                                    " ",
                                    "information",
                                    React.createElement("i", { className: `m-l-mini ${isExtended
                                            ? "icon-chevron-up"
                                            : "icon-chevron-down"}` }))),
                            React.createElement("div", { className: "column" },
                                React.createElement("button", { "data-ecom-button": "small", onClick: onChooseInsurance }, "V\u00E4lj"))))))),
        React.createElement("section", { className: "page-section" },
            React.createElement("button", { "data-ecom-button": "full-width light", onClick: onSkipInsurance }, "Hoppa \u00F6ver detta steg"))));
};
